export const shortenNumber = (number: number, decimals = 1) => {
  const absNumber = Math.abs(number);
  if (absNumber < 100) return number;
  if (absNumber < 100000) return `${(number / 1000).toFixed(decimals)}k`;
  return `${(number / 1000000).toFixed(decimals)}M`;
};
